import React, { Component } from 'react';

class Pagination extends Component {

    render() {

        let { slides, active, switchSlide } = this.props

        return (

            <ul className="pagination" role="tablist" aria-label="Carousel slide navigation">

                {slides.map((item, index) => {

                    let slideClass = (active === index) ? 'active' : ''

                    const isActive = active === index;

                    return <li key={index} className={slideClass} role="none">
                        
                        <button 
                            onClick={() => switchSlide(index)}
                            role="tab"
                            aria-selected={isActive}
                            aria-label={`Go to slide ${index + 1}: ${item.project || 'Project'}`}
                            aria-controls={`slide-${index}`}
                            tabIndex={isActive ? -1 : 0}
                        >
                            0{index + 1}
                        </button>
                    </li>
                })}

            </ul>

        );
    }
}

export default Pagination;